import {api, BASE_URL} from "../config";

const FILES_URL = BASE_URL + "files/"; // ex: /api/files/

// ✅ Récupère tous les documents (le back renvoie tout)
export function get_all_documents_by_folder() {
    return api.get(FILES_URL).then((res) => res.data);
}

// ✅ Envoie d’un document (FormData : file + metadata)
export function upload_document(formData) {
    return api.post(FILES_URL, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    }).then((res) => res.data);
}



export function delete_document(fileId) {
    return api.delete(`${FILES_URL}${fileId}`).then(res => res.data);
}


export function delete_folder(folderName) {
    return api.delete(`${FILES_URL}folder/${encodeURIComponent(folderName)}`).then((res) => res.data);
}

export async function get_referentiel_download_url(fileId) {
    const res = await api.get(`${FILES_URL}${fileId}/download-url`);
    return res.data?.data?.url;
}

export async function open_referentiel_document(fileId) {
    const url = await get_referentiel_download_url(fileId);
    if (!url) throw new Error("URL de consultation introuvable");

    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    a.remove();
}

export async function download_referentiel_document(fileId, filename) {
    const url = await get_referentiel_download_url(fileId);
    if (!url) throw new Error("URL de téléchargement introuvable");

    const a = document.createElement("a");
    a.href = url;
    if (filename) a.download = filename; // optionnel si backend OK
    document.body.appendChild(a);
    a.click();
    a.remove();
}

